var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONExerciseAttendClass extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.deltakernavn = '';
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "avdeling", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "avdelingnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "book_inntil", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "booked", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "booked_text", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "booking", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "booking_starts_at", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "color", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "cost", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "cost_excluded_vat", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "dagerfor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "dato", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "deltakernavn", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "error", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "free", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "gren", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "grennavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "gyldig_fra", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "gyldig_til", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "instructor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONExerciseAttendClass.prototype, "is_attending", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "klipp", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "lang_beskrivelse", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "min", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "res_slettes", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "sal", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "salnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONExerciseAttendClass.prototype, "skjul_antall_ledige", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "slett_vente_min", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "source", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "tema_time", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "tidspunkt", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "tim", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseAttendClass.prototype, "tittel", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "varighet", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseAttendClass.prototype, "waitingspot", void 0);
